// extracted by css-extract-rspack-plugin
export default {"iconWrapper":"icon-wrapper--XdtMXOPHsFQfMzix","buttonStretched":"button-stretched--oFbGa6g8Q4jeMEfC"};